export default __webpack_public_path__ + "static/media/h5datasourcemgr-hover.dbe91b90.svg";